'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactScroll = require('react-scroll');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _FAQs = require('./FAQs.css');

var _FAQs2 = _interopRequireDefault(_FAQs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FAQs = (_dec = (0, _reactCssModules2.default)(_FAQs2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(FAQs, _Component);

  function FAQs(props) {
    (0, _classCallCheck3.default)(this, FAQs);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FAQs.__proto__ || (0, _getPrototypeOf2.default)(FAQs)).call(this, props));

    _this.state = {
      title: 'FAQs',
      description: 'Frequently Asked Questions about sustainable investing in employer-offered retirement plans.',
      url: _config2.default.domain + _config2.default.routes.faqs
    };
    return _this;
  }

  (0, _createClass3.default)(FAQs, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement('div', { styleName: 'anchor', id: 'top' }),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'faq-wrap' },
            _react2.default.createElement(
              'h1',
              { styleName: 'small-page-title' },
              this.state.title
            ),
            _react2.default.createElement(
              'nav',
              null,
              [['do-i-have-to-sacrifice-returns-in-order-to-invest-sustainably-', 'Do I have to sacrifice returns in order to invest sustainably?'], ['why-should-retirement-plans-add-a-sustainable-investment-option-', 'Why should retirement plans add a sustainable investment option?'], ['what-are-my-next-steps-if-i-want-a-sustainable-investment-option-in-my-retirement-plan-', 'What are my next steps if I want a sustainable investment option in my retirement plan?'], ['what-is-the-most-effective-solution-to-make-a-retirement-fund-sustainable-', 'What is the most effective solution to make a retirement fund sustainable?'], ['how-are-the-grades-for-my-retirement-plan-scorecard-assigned-', 'How are the grades for my retirement plan scorecard assigned?'], ['why-are-scorecard-grades-based-off-of-the-default-option-', 'Why are scorecard grades based off of the default option?'], ['where-does-the-data-for-my-retirement-plan-scorecard-come-from-', 'Where does the data for my retirement plan scorecard come from?'], ['how-are-companies-chosen-to-have-their-retirement-plans-rated-', 'How are companies chosen to have their retirement plans rated?'], ['when-will-my-company-39-s-scorecard-be-listed-on-the-website-', 'When will my company\'s scorecard be listed on the website?'], ['is-offering-a-self-directed-option-brokerage-window-enough-', 'Is offering a self-directed option (brokerage window) enough?'], ['how-can-i-see-which-companies-i-am-invested-in-through-my-401-k-', 'How can I see which companies I am invested in through my 401(k)?'], ['what-is-sustainable-investing-', 'What is sustainable investing?'], ['what-is-esg-investing-', 'What is ESG investing?'], ['what-is-a-target-date-fund-', 'What is a target date fund?'], ['what-is-a-default-option-', 'What is a default option?'], ['can-i-still-align-my-investments-with-my-values-if-i-don-39-t-have-a-401-k-', 'Can I still align my investments with my values if I don\'t have a 401(k)?'], ['why-is-it-important-to-invest-fossil-free-', 'Why is it important to invest fossil free?'], ['why-is-it-important-to-invest-deforestation-free-', 'Why is it important to invest deforestation free?'], ['what-is-the-prison-industrial-complex-', 'What is the prison industrial complex?'], ['what-are-private-prisons-', 'What are private prisons?'], ['how-can-asset-managers-use-their-shareholder-power-to-slow-the-climate-crisis-', 'How can asset managers use their shareholder power to slow the climate crisis?'], ['why-do-asset-managers-need-to-expand-their-exclusion-policies-', 'Why do asset managers need to expand their exclusion policies?'], ['what-does-fiduciary-duty-mean-for-asset-manager-39-s-ability-to-act-on-climate-', 'What does Fiduciary Duty mean for asset manager\'s ability to act on climate?'], ['what-is-vanguard-39-s-climate-risk-', 'What is Vanguard\'s climate risk?'], ['what-can-vanguard-do-about-its-passive-investments-in-companies-driving-the-climate-crisis-', 'What can Vanguard do about its passive investments in companies driving the climate crisis?'], ['is-staying-invested-and-engaging-with-a-company-a-better-strategy-for-change-than-pulling-investments-out-of-a-destructive-company-', 'Is staying invested and engaging with a company a better strategy for change than pulling investments out of a destructive company?'], ['what-can-asset-managers-really-do-given-that-they-work-with-client-money-', 'What can asset managers really do, given that they work with client money?']].map(function (e, i) {
                return _react2.default.createElement(
                  'button',
                  {
                    key: e[0],
                    styleName: 'scroll-to-item'
                  },
                  _react2.default.createElement(
                    _reactScroll.Link,
                    {
                      to: e[0],
                      spy: true,
                      smooth: true,
                      duration: 500,
                      title: e[1]
                    },
                    e[1]
                  )
                );
              })
            ),
            _react2.default.createElement(
              'h2',
              { id: 'do-i-have-to-sacrifice-returns-in-order-to-invest-sustainably-' },
              'Do I have to sacrifice returns in order to invest sustainably?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'While many investors believe you must sacrifice returns in order to invest your values, often times ',
              _react2.default.createElement(
                'strong',
                null,
                'adding unsustainable investments'
              ),
              ' to your portfolio could actually be',
              _react2.default.createElement(
                'em',
                null,
                ' ',
                _react2.default.createElement(
                  'strong',
                  null,
                  'increasing'
                ),
                ' '
              ),
              ' ',
              _react2.default.createElement(
                'strong',
                null,
                'your financial risk'
              ),
              '. ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://www.ussif.org/performance' },
                'Numerous studies'
              ),
              ' have shown that sustainable funds are able to provide returns in line with their traditional counterparts over the short and long-term, and are often less risky investments.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'As investors across the world continue to enter the ESG market at an exponential rate, they are beginning to realize that sustainable investing is no longer a zero-sum game. By investing your values, you can actualize returns, ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: '/action-center/financial-risks' },
                'avoid financial risk'
              ),
              ', while supporting the transition to an economy that is based on justice and sustainability.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'why-should-retirement-plans-add-a-sustainable-investment-option-' },
              'Why should retirement plans add a sustainable investment option?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'There are a number of reasons why retirement plans should offer sustainable investment options to plan participants:'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Financial performance:'
                ),
                '  Several ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://www.ussif.org/performance' },
                  'studies'
                ),
                ' have shown that, on average, the financial performance of sustainable funds has been comparable to or even outperformed their traditional counterparts, including during years of economic volatility and recession.'
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Personal values/priorities:'
                ),
                '  Some individuals seek investment options that align with their ethical concerns and priorities, such as weapons avoidance or animal welfare.'
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Positive impact:'
                ),
                '  Others want investments that, like their charitable giving, contribute to important societal or environmental issues such as women\'s advancement and addressing climate change.'
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'what-are-my-next-steps-if-i-want-a-sustainable-investment-option-in-my-retirement-plan-' },
              'What are my next steps if I want a sustainable investment option in my retirement plan?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Check with your human resources (HR) department; your plan may already have sustainable investment options. If not, let appropriate personnel know about your interest in such options. Many retirement plan platforms have an open structure that enables the addition of new funds.'
            ),
            _react2.default.createElement(
              'p',
              null,
              ' Additional resources available to your employer or investment committee include:'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://www.ussif.org/sribasics' },
                  'Sustainable investing basics'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://www.ussif.org/performance' },
                  'Financial performance with sustainable investing'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                'Resources to research and find sustainable investment mutual funds and ETFs from ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://charts.ussif.org/mfpc/' },
                  'US SIF\'s online chart'
                ),
                ' and ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://www.asyousow.org/invest-your-values' },
                  'As You Sow\'s Invest Your Values'
                ),
                ' tool'
              ),
              _react2.default.createElement(
                'li',
                null,
                'Free 30-minute course on ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://www.ussif.org/courses_individualinvestors' },
                  _react2.default.createElement(
                    'em',
                    null,
                    'Sustainable Investing: An Introductory Course for Individual Investors'
                  )
                )
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'what-is-the-most-effective-solution-to-make-a-retirement-fund-sustainable-' },
              'What is the most effective solution to make a retirement fund sustainable?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Retirement plans must, at a bare minimum, offer sustainable investing options to plan participants. But even when plans offer sustainable options in the line-up, they often have a small percentage of the plan assets invested in them. This is because most plan participants stick with the default option in the plan, the option that a new participant\'s contributions are allocated to if they don\'t specify another fund. So long as the default option in a retirement plan is not invested sustainably, retirement plans will continue investing significant amounts of their plan assets unsustainably.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'how-are-the-grades-for-my-retirement-plan-scorecard-assigned-' },
              'How are the grades for my retirement plan scorecard assigned?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The Retirement Plan Sustainability Scorecard rates employer-offered 401(k)s and other retirement plans based on their investments in fossil fuels, arms manufacturers, and other environmentally and socially risky companies. We ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: '/methodology' },
                'allocate grades'
              ),
              ' to a plan\'s retirement investment options based off of the plan\'s default option, or the ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://www.betterment.com/resources/what-is-a-qualified-default-investment-alternative-qdia/' },
                'Qualified Default Investment Alternative (QDIA).'
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'why-are-scorecard-grades-based-off-of-the-default-option-' },
              'Why are scorecard grades based off of the default option?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'We ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: '/methodology' },
                'based our scorecards'
              ),
              ' off of the default option because it often commands the majority of the plan assets. That\'s natural, as it\'s the option to which new plan participants have their contributions allocated, and many people never switch.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'For many plans, the default investment is a series of ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: '/methodology#targetdates' },
                'target date funds'
              ),
              ', broadly diversified investments that offer different "target dates" for older or younger investors, and mostly hold index funds with an "own the market" philosophy. Target date series are often offered in a variety of asset classes - we use the mutual fund offerings of these portfolios to calculate the scorecard result for your retirement plan.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'where-does-the-data-for-my-retirement-plan-scorecard-come-from-' },
              'Where does the data for my retirement plan scorecard come from?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'We gather the data for each retirement plan from the Department of Labor (DOL), ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://www.paychex.com/articles/employee-benefits/everything-to-know-form-5500-responsibilities' },
                'form 5500,'
              ),
              ' which is filled out by companies each year. The IRS Form 5500 is an annual report, filed with the U.S. DOL that contains information about a 401(k) plan\'s financial condition, investments, and operation.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'how-are-companies-chosen-to-have-their-retirement-plans-rated-' },
              'How are companies chosen to have their retirement plans rated?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'We think every retirement plan should be rated on sustainability. Our goal is to expand this database to cover the S&P 500 over the next year. We started with ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: '/retirement-plans/amazon-com' },
                'Amazon.com'
              ),
              ' and ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: '/retirement-plans/comcast' },
                'Comcast'
              ),
              ' because they are major brands that most people will recognize, with hundreds of thousands of participants and billions in assets invested in their employee retirement plans. But the sustainability issues with their retirement plans are not unique to these two companies. Check back regularly to see if your employer has been added to our database. Want us to rate the retirement plan of your employer? ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://www.asyousow.org/contact' },
                'Get in touch with us'
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'when-will-my-company-39-s-scorecard-be-listed-on-the-website-' },
              'When will my company\'s scorecard be listed on the website?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Over the next year, we will be continually adding corporate retirement plans to our website, and plan to have scorecards for the entire S&P 500 by then end of 2022. If you subscribe to ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://go.asyousow.org/sign-up-invest-your-values' },
                'our email,'
              ),
              ' we will happily send you a notification when your plan is up.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'is-offering-a-self-directed-option-brokerage-window-enough-' },
              'Is offering a self-directed option (brokerage window) enough?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Retirement plans must, at a bare minimum, offer sustainable investing options to plan participants. The lowest bar is offering a self-directed option so people can find sustainable mutual funds or ETFs to invest in. But this puts risk on the employees, who must figure out what is the best investment for their circumstances from a universe of thousands of funds. A better way is to ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: '/the-solutions/offer-sustainability' },
                'include sustainable investment options'
              ),
              ' directly in the plan line-up. Every retirement plan should at least offer some fund options that exclude ESG risky companies like fossil fuel companies; deforestation-risk agribusiness commodity producer/traders; tobacco manufacturers; arms manufacturers and military contractors; civilian firearm manufacturers; and incorporates a gender-lens investment lens.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'how-can-i-see-which-companies-i-am-invested-in-through-my-401-k-' },
              'How can I see which companies I am invested in through my 401(k)?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Retirement plans invest in mutual funds and ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: '/methodology#targetdates' },
                'target date funds'
              ),
              ', which often invest in hundreds of different companies. If you would like to see which individual companies you are invested in, visit your plan\'s scorecard. By clicking on each individual issues area on the scorecard, you will see the logo of some of the biggest companies in that fund in the pop up. By clicking on "more results" link at the bottom of the popup, and scrolling down on the new page, you can see some of the top 5 holdings from the various industries.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'If your plan is not listed, but you are invested in your company\'s default option, you can visit our ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: '/target-date-funds' },
                'target date page'
              ),
              ' to see the what grades your specific target date receives for each issues area. By scrolling down, you can see some of the top flagged holdings in each target date fund.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'what-is-sustainable-investing-' },
              'What is sustainable investing?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Sustainable investing focuses on directing capital into companies and industries that are working to combat climate change, promote social responsibility, and ensure ethical governance. You may have heard of the term "ESG" investing which stands for Environment, Social, and Governance. Another acronym is "SRI" which stands for Socially Responsible Investing. All these terms are generally interchangeable, and are all investing strategies that seek to achieve financial returns while bringing about positive environmental and social change.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'what-is-esg-investing-' },
              'What is ESG investing?'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://www.nerdwallet.com/article/investing/esg-investing' },
                'ESG, or Environmental, Social, and Governance'
              ),
              ', is an umbrella term for investing in funds that seeks both ',
              _react2.default.createElement(
                'strong',
                null,
                'positive financial returns and long-term positive social and environmental impacts'
              ),
              '. Across the world, employees are already seeing that climate change, gender inequality, rainforest destruction, and weapons are destroying their future. Most would not choose to invest in or profit from that destruction.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'what-is-a-target-date-fund-' },
              'What is a target date fund?'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: '/methodology#targetdates' },
                'Target date funds'
              ),
              ' are a series of funds, where each fund in the series targets a different mix of stocks and bonds for investors with different retirement time horizons. The default option in employer-offered retirement plans is often a target date fund series.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'what-is-a-default-option-' },
              'What is a default option?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Most employer-offered retirement plans have what\'s called a ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://www.betterment.com/resources/what-is-a-qualified-default-investment-alternative-qdia/' },
                'Qualified Default Investment Alternative (QDIA).'
              ),
              ' When you sign up for the plan, your savings are put in a default investment if you don\'t otherwise specify. And for many plans, that default investment is a series of ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: '/methodology#targetdates' },
                'target date funds'
              ),
              ', broadly diversified investments that offer different "target dates" for older or younger investors, and mostly hold index funds with an "own the market" philosophy.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'can-i-still-align-my-investments-with-my-values-if-i-don-39-t-have-a-401-k-' },
              'Can I still align my investments with my values if I don\'t have a 401(k)?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'In order to align investments with values, you must first know what companies you own. Finding out what mutual funds are investing in is not obvious, but you can get some info on them with a few steps. ',
              _react2.default.createElement(
                'em',
                null,
                'As You Sow'
              ),
              ' has seven ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://www.asyousow.org/invest-your-values' },
                'online Invest Your Values tools'
              ),
              ', that can show you exactly what companies are embedded in your funds and which funds are aligned with your values.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'why-is-it-important-to-invest-fossil-free-' },
              'Why is it important to invest fossil free?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Coal, oil, and gas release carbon pollution that ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: '/the-issues/fossil-fuels' },
                'accelerates the climate emergency'
              ),
              '. Rising temperatures will contribute to fires, floods, deadly heatwaves, and other environmental disasters.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Owning investments in coal companies, oil/gas producers, and coal-fired utilities isn\'t just a moral question. Fossil fuel investments carry real ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: '/action-center/financial-risks' },
                'financial risks.'
              ),
              ' When emissions are constrained, fossil fuel companies will have their carbon assets stranded. The implication is that they\'re massively overvalued, and markets are realizing that investing in fossil fuels is a risky bet. Additionally, laws curbing the use of fossil fuels are being put in place, energy efficiency measures are being implemented across nearly every sector of the economy, and renewable energy is driving down demand for fossil fuel-based energy. These changes pose substantial financial risk to fossil fuel companies.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'why-is-it-important-to-invest-deforestation-free-' },
              'Why is it important to invest deforestation free?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Deforestation-risk agricultural commodity producer/traders are companies that produce and distribute commodities that involve deforestation in their production processes. There are multiple steps in a typical cycle of deforestation, providing multiple opportunities for profiteers to play a role in forest destruction. First, old growth trees are logged for  ',
              _react2.default.createElement(
                'strong',
                null,
                'timber'
              ),
              '  and other industrial purposes, often by illegal loggers (',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://prod.greenpeaceusa.info/usa/research/logging-the-amazons-silent-crisis/' },
                'Greenpeace has cited'
              ),
              ' a study that in one state in Brazil, almost 80% of all logging is carried out by illegal loggers). Harvested trees require further deforestation to take place in order to be transported to market, and a logged forest is significantly less biodiverse and more vulnerable to fire. Once old growth trees are gone, ranchers typically burn what is left to clear the land for  ',
              _react2.default.createElement(
                'strong',
                null,
                'cattle grazing'
              ),
              '. This leads to a further loss of biodiversity and a depletion of soil nutrients. Eventually, the only crops that can be grown in the areas where deforestation has taken place are  ',
              _react2.default.createElement(
                'strong',
                null,
                'monocrops'
              ),
              '   ',
              _react2.default.createElement(
                'strong',
                null,
                'like palm oil or soy'
              ),
              '. Monocrops can typically only grow with exorbitant amounts of fertilizers, and are highly susceptible to pests or disease.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Vanguard and other asset management firms may not be directly cutting down forests, but when they choose to invest their clients\' money in deforestation commodity companies, they are perpetuating a destructive cycle. Instead of turning a blind eye in the interest of profit, Vanguard and other firms like it must insist that any companies it invests in have clear policies with safeguards in place to ensure that their products are not being sourced from deforested lands.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'what-is-the-prison-industrial-complex-' },
              'What is the prison industrial complex?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'http://criticalresistance.org/about/not-so-common-language/' },
                'prison industrial complex'
              ),
              ' is a term used to describe the overlapping interests of government and industry that use surveillance, policing, and imprisonment as solutions to economic, social and political problems. On this website, a plan\'s scorecard receives a grade based on two aspects of the prison industrial complex: companies involved in the prison industry (such as private for-profit prison operators and prison services providers), and companies involved in the militarization of borders and the policing of immigration.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'what-are-private-prisons-' },
              'What are private prisons?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'A private prison, also known as a for-profit prison, are run by private companies that are contracted by the government to house people who have violated the law. For-profit firms have flooded money into prison and immigration jail infrastructure and services, and have used industry associations to lobby for harsher policing and longer sentencing, even for non-violent offenders. Mass incarceration is one manifestation of racist policy, particularly devastating for poor communities, immigrants, people of color, and their families. People who are incarcerated work for pennies per hour while their families pay exorbitant fees to keep them supplied with bare necessities. Powerful, private equity interests and corporations reap enormous profits from the militarization of the U.S.-Mexico border and the policing of immigration.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'how-can-asset-managers-use-their-shareholder-power-to-slow-the-climate-crisis-' },
              'How can asset managers use their shareholder power to slow the climate crisis?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Asset managers can implement public and visible consequences for companies that are not moving fast enough to align with the low carbon economy we need. Companies that are not moving toward science-based targets are not just a risky investment, they are endangering global security, financial and otherwise, and asset managers, like Vanguard, have the power to push these companies to change.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'why-do-asset-managers-need-to-expand-their-exclusion-policies-' },
              'Why do asset managers need to expand their exclusion policies?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'There are certain climate-harming industries that will never be sustainable, like coal, tar sands, and Arctic oil. These must be investment no-go sectors. The science is clear that we need to phase out these fossil fuels as soon as possible, so any investment in them is a risk for our economy and our planet. While ESG exclusionary screens can be a good tool, simply integrating ESG data is vague and in its current form will not eliminate climate-destroying companies from investment funds.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'what-does-fiduciary-duty-mean-for-asset-manager-39-s-ability-to-act-on-climate-' },
              'What does Fiduciary Duty mean for asset manager\'s ability to act on climate?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Climate change poses an enormous systemic risk to our economy. Given the systematic threat of climate change, the only way a financial firm can fulfill its long-term fiduciary duty to its clients is by proactively acting to mitigate the climate crisis. Financial firms that do not take the climate impact of their investments into account are not acting in the best interest of their clients or our economy.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'what-is-vanguard-39-s-climate-risk-' },
              'What is Vanguard\'s climate risk?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Vanguard\'s investments pour billions into the industries that are destroying the climate which include exposure to fossil fuel companies, companies that are driving unprecedented fires in the Amazon Rainforest, and other morally problematic corporations. According to a ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://ieefa.org/wp-content/uploads/2021/06/Vanguard-Group_Passive-About-Climate-Change_June-2021.pdf' },
                'recent study'
              ),
              ', Vanguard is the world\'s largest investor in fossil fuels, making them a global laggard when it comes to climate.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Despite stated environmental priorities by the company, ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://ieefa.org/ieefa-vanguard-funds-destroy-shareholder-wealth-with-us290bn-in-fossil-fuels-creating-a-5-6-performance-drag/' },
                'Vanguard continues to lag behind its peers'
              ),
              ' by failing to take the necessary steps to address climate change. Asset managers across the world have been steadily reducing their exposure to stranded assets by divesting from coal, oil and gas. On the other hand, Vanguard still has roughly ',
              _react2.default.createElement(
                'strong',
                null,
                '$300 billion invested in oil and gas, and $90 billion in thermal coal'
              ),
              ' , with no plans to divest any time soon. Until Vanguard recognizes that climate change is a major threat to their clients\' investments, they will continue to be an industry laggard.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'what-can-vanguard-do-about-its-passive-investments-in-companies-driving-the-climate-crisis-' },
              'What can Vanguard do about its passive investments in companies driving the climate crisis?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'True climate leadership must include taking responsibility for avoiding systemic impacts to the financial system and economy overall. Vanguard\'s existing portfolio, unchecked, is driving runaway climate change. The notion that passive funds are derived through objective analyses of the market is simply not true, in reality index funds are "',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://digitalcommons.law.yale.edu/cgi/viewcontent.cgi?article=1546&context=yjreg' },
                'passive in name only'
              ),
              '." Selection criteria are created by fund managers, and their methodologies shift regularly. It is past time for fund managers to think seriously about how climate change is a crucial criterion.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'is-staying-invested-and-engaging-with-a-company-a-better-strategy-for-change-than-pulling-investments-out-of-a-destructive-company-' },
              'Is staying invested and engaging with a company a better strategy for change than pulling investments out of a destructive company?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Any investor \u2013 particularly one with the capacity of an asset manager like Vanguard \u2013 is a future share buyer and ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://papers.ssrn.com/sol3/papers.cfm?abstract_id=3314906' },
                'therefore a company is incentivized to engage'
              ),
              '. Total unwillingness to consider exit as an option would likely decrease the power of an asset manager\'s engagement, according to Albert Hirschman in his book, ',
              _react2.default.createElement(
                'em',
                null,
                'Exit, Voice, and Loyalty'
              ),
              '. Academic analysis ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://ideas.repec.org/a/kap/jbuset/v125y2014i2p193-210.html' },
                'has found'
              ),
              ' that investors that sell shares do not lose the proverbial "seat at the table," but in fact can continue to engage both publicly and privately.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'h2',
              { id: 'what-can-asset-managers-really-do-given-that-they-work-with-client-money-' },
              'What can asset managers really do, given that they work with client money?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Most major asset managers, including Vanguard, have said that climate change is a major threat to clients\' investments, so continuing to support the companies driving climate change makes asset managers part of that threat. There is an inherent conflict between the long-term survival of companies whose core business model is based on fossil fuels or deforestation and the long-term existence of life as we know it. Continuing to hold fossil fuel companies in a portfolio is an abdication of long-term fiduciary responsibility. Until it pursues action that aims to materially reduce greenhouse gas emissions, asset managers like Vanguard, are trying to have their cake and eat it, too.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null)
          )
        ),
        _react2.default.createElement(_components.RiskTypeLinks, null),
        _react2.default.createElement(_components.HomeEduCenter, null)
      );
    }
  }]);
  return FAQs;
}(_react.Component)) || _class);
exports.default = FAQs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/FAQs/FAQs.js
// module id = 1476
// module chunks = 0